<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="default_type_value_list" class="elevation-1 mytable" dense
      :search="search">
      <template v-slot:top>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Default Type Value</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
            :style="{ 'background-color': 'white', 'color': 'black' }">
            >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="success" small :disabled="isallowed == false ? true : false" v-on="on">Add Default Type Value</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined rounded dense color="#0F2027" v-model="editedItem.default_type"
                          persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: Exam, SMS...'
                              : 'For example ::  Exam, SMS...'
                          " label="Enter Default Type Value" :rules="[(v) => !!v || 'required']">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    errorMsg: {
      quizId: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Default Type Value",
        align: "left",
        sortable: false,
        value: "default_type",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    default_type_value_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      default_type: "",
      //isactive:true
    },
    defaultItem: {
      id: "",
      default_type: "",
      // daysequence:'',
      //isactive:true
    },
    isallowed:false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Default Type Value"
        : "Edit Default Type Value";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    // initializeErrorMsgFalse() {
    //   this.errorMsg.standard = false;
    // },
    onLoad() {
      this.overlay = true;
      axios
        .post("/RoleManagement/adminDefaultType")
        .then((res) => {
          if (res.data.flag == "YES") {
            if ((this.load = true)) {
              this.overlay = false;
              this.default_type_value_list = res.data.default_type_value_list;
              this.isallowed=res.data.isallowed
            }
          } else if(res.data.flag == 'No'){
            this.showSnackbar("red", res.data.snackbar);
              this.isallowed=res.data.isallowed;
              this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.default_type_value_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // alert(this.editedIndex)
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/RoleManagement/editAdminDefaultType", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.default_type_value_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Default Type Value Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Default Type Value Already Present!!!"
                ); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/RoleManagement/saveAdminDefaultType", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.default_type_value_list.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "Default Type Value Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Default Type Value Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.id) {
        return true;
      } else {
        if (!this.editedItem.id) {
          this.errorMsg.id = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
